import { render, staticRenderFns } from "./AuthoritySetting.vue?vue&type=template&id=173508d5"
import script from "./AuthoritySetting.vue?vue&type=script&lang=js"
export * from "./AuthoritySetting.vue?vue&type=script&lang=js"
import style0 from "./AuthoritySetting.vue?vue&type=style&index=0&id=173508d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports